// extracted by mini-css-extract-plugin
export default {"fullscreenContainer":"LoadingSpinner_fullscreenContainer__HxK6G","contentContainer":"LoadingSpinner_contentContainer__ujBMd"};